import { dictionaries } from "../dictionaries";
import { getFormattedTime } from "./get-formatted-time";
import { getFormattedNumber } from "./get-formatted-number";

const { MONTHS_SHORT, MONTHS_FULL } = dictionaries.date;

const getFormat: Record<string, (date: string) => string> = {
  "dd-MM-yyyy": (dateStr) => {
    const date = new Date(dateStr);
    const day = getFormattedNumber(date.getDate());
    const month = getFormattedNumber(date.getMonth() + 1);
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  },
  "yyyy-MM-dd": (dateStr) => {
    const date = new Date(dateStr);
    const day = getFormattedNumber(date.getDate());
    const month = getFormattedNumber(date.getMonth() + 1);
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
  },
  "dd MMMM": (dateStr) => {
    const date = new Date(dateStr);
    const day = getFormattedNumber(date.getDate());
    const month = MONTHS_FULL[date.getMonth()];

    return `${day} ${month}`;
  },
  "dd LLL, HH:mm": (dateStr) => {
    const date = new Date(dateStr);
    const day = getFormattedNumber(date.getDate());
    const month = MONTHS_SHORT[date.getMonth()];
    const time = getFormattedTime(dateStr, "HH:mm");

    return `${day} ${month}, ${time}`;
  },
};

export const getFormattedDate = (
  date: string,
  format: keyof typeof getFormat = "dd-MM-yyyy"
) => getFormat[format](date);
